<template>
  <table class="table table-striped table-light table-hover" id="tablaAcuerdos">
    <thead class="thead-dark">
      <tr>
        <!-- <th class="col-2">Consecutivo</th>
        <th class="col-3">Denunciante</th> -->
        <th class="col-2">Fecha de Acuerdo</th>
        <th class="col-4">Extracto</th>
        <th class="col-1">Acciones</th>
      </tr>
    </thead>
    <tbody class="text-dark">
      <tr>
        <td colspan="5">
          Investigación y calificación de Falta Administrativa
        </td>
      </tr>
      <tr v-for="acuerdo in listaDeAcuerdos" v-bind:key="acuerdo.acuerdoId">
        <!-- <td>{{faltaAdministrativa.consecutivo}}</td>
        <td v-if="faltaAdministrativa.denunciante">{{faltaAdministrativa.denunciante}}</td>
        <td v-else>Anónimo</td> -->
        <td>
          {{
            new Date(acuerdo.fechaDeDictado).toLocaleDateString(
              "es-MX",
              opcionesFechaLocal
            )
          }}
        </td>
        <td>{{ acuerdo.extracto }}</td>
        <td>
          <i class="fas fa-edit fa-lg" title="Editar Acuerdo" />
          <i class="fas fa-trash fa-lg" title="Eliminar Acuerdo" />
        </td>
      </tr>
      <tr v-if="listaDeAcuerdos.length == 0">
        <td colspan="3">No se encontraron acuerdos.</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import store from "@/store/index";
import { Acuerdo } from "@/components/SIFA/Comun/Modelos/Acuerdo.js";
export default {
  data() {
    return {
      listaDeAcuerdos: [],
      faltaAdministrativa: {
        consecutivo: "IUCI/PJE/0001-07-2021",
        denunciante:
          "MA. GUADALUPE ENRIQUEZ CIDA y ALEJANDRO ANTONIO FABRE GERARD.",
      },
      opcionesFechaLocal: {
        year: "numeric",
        month: "numeric",
        day: "numeric",
      },
    };
  },
  props: {
    prop_listaDeAcuerdos: Array[Acuerdo],
  },
  components: {},
  methods: {},
  mounted: function mounted() {
    if (this.prop_listaDeAcuerdos)
      this.listaDeAcuerdos = this.prop_listaDeAcuerdos;
  },
  computed: {},
};
</script>

<style scoped>
span {
  font-weight: bold;
}

b {
  padding-right: 3px;
}

.new-row {
  margin-top: 20px;
}

.bigtextarea {
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/TablaDeAcuerdos.vue